import { SideResponse } from "../codegen-api";
import { COLORS } from "../constants/design/colors";

/**
 * The direction color scale for a trade side — up (buy / long / green) vs down
 * (sell / short / red). Returns the whole `COLORS.up` / `COLORS.down` object so
 * callers pick the shade they need:
 *   - `.one`  solid fill / colored text on a dark background
 *   - `.on`   WCAG-adaptive text/icon color to place ON a `.one` fill
 *   - `.four` / `.five` / `.six`  translucent tints (glows, chip backgrounds)
 *
 * Single source of truth for the buy/sell color choice — replaces the
 * `side === SideResponse.Buy ? COLORS.up.x : COLORS.down.x` ternaries that were
 * duplicated across the trade form (submit button, side toggles, position chip,
 * executed-trade bar, margin selector). No visual change — same tokens.
 */
export function sideColors(side: SideResponse) {
  return side === SideResponse.Buy ? COLORS.up : COLORS.down;
}
